import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth-guard/auth.guard';
import { LoginComponent } from './authuntication/login/login.component';
import { ErrorPaymentComponent } from './static-pages/payment/error-payment/error-payment.component';
import { SuccessPaymentComponent } from './static-pages/payment/success-payment/success-payment.component';
import { PublicBookingComponent } from './static-pages/booking/public-booking/public-booking.component';

const routes: Routes = [
  { path: "", redirectTo: "healthcare", pathMatch: "full" },
  { path: "login", component: LoginComponent },
  { path: "error-payment", component: ErrorPaymentComponent },
  { path: "success-payment", component: SuccessPaymentComponent },
  { path: "reception-reservations", component: PublicBookingComponent },
  {
    path: 'health-care-payment', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/admin/components/payments/payments.module').then(m => m.PaymentsModule)
  },
  {
    path: 'healthcare', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/admin/components/health-care/health-care.module').then(m => m.HealthCareModule)
  },
  {
    path: 'marketer-orders', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/admin/components/marketers/marketers.module').then(m => m.MarketersModule)
  },
  {
    path: 'new-order', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/admin/components/requests/booking/orders/orders.module').then(m => m.OrdersModule)
  },
  {
    path: 'logout', canActivate: [AuthGuard],
    loadChildren: () => import('./shared-component/components/logout/logout.module').then(m => m.LogoutModule)
  },
  {
    path: 'service', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/all-services/service-list/service-list.module').then(m => m.ServiceListModule)
  },
  {
    path: 'hc-services', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/all-services/get-services-by-admin/get-services-by-admin.module').then(m => m.GetServicesByAdminModule)
  },
  {
    path: 'doctors', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/medical/doctors/doctors.module').then(m => m.DoctorsModule)
  },
  {
    path: 'versions-doctors', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/medical/versions-doctor/versions-doctor.module').then(m => m.VersionsDoctorModule)
  },
  {
    path: 'join-request-doctors', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/medical/requests/requests.module').then(m => m.RequestsModule)
  },
  {
    path: 'positions', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/medical/positions/positions.module').then(m => m.PositionsModule)
  },
  {
    path: 'requests', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/admin/components/requests/pinding/pinding.module').then(m => m.PindingModule)
  },
  {
    path: 'offer', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/admin/components/offers/offers.module').then(m => m.OffersModule)
  },
  {
    path: 'contacts', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/admin/components/contacts/contacts.module').then(m => m.ContactsModule)
  },
  {
    path: 'rejected', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/admin/components/requests/rejected/rejected.module').then(m => m.RejectedModule)
  },
  {
    path: 'city', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/locations/cities/cities.module').then(m => m.CitiesModule)
  },
  {
    path: 'pindind-sub-service', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/all-services/pinding/pinding.module').then(m => m.PindingModule)
  },
  {
    path: 'admin', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'sub-service-List', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/all-services/sub-service/sub-service.module').then(m => m.SubServiceModule)
  },
  {
    path: 'sub-service', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/admin/components/all-services/sub-services/sub-services.module').then(m => m.SubServicesModule)
  },
  {
    path: 'taxes', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/taxes-commissions/taxes/taxes.module').then(m => m.TaxesModule)
  },
  {
    path: 'Add-service-healthcare', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/all-services/add-services/add-services.module').then(m => m.AddServicesModule)
  },
  {
    path: 'service-healthcare', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/admin/components/all-services/hc-service/hc-service.module').then(m => m.HcServiceModule)
  },
  {
    path: 'commision', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/taxes-commissions/commissions/commissions.module').then(m => m.CommissionsModule)
  },
  {
    path: 'mobile-version', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/mob-version/mob-version.module').then(m => m.MobVersionModule)
  },
  {
    path: 'activity-logs', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/activity-logs/activity-logs.module').then(m => m.ActivityLogsModule)
  },
  {
    path: 'add-zone', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/locations/add-zones/add-zones.module').then(m => m.AddZonesModule)
  },
  {
    path: 'zones', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/locations/zones/zones.module').then(m => m.ZonesModule)
  },
  {
    path: 'app-version', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/versions/versions.module').then(m => m.VersionsModule)
  },
  {
    path: 'refund-Booking', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/admin/components/requests/booking/refund-booking/refund-booking.module').then(m => m.RefundBookingModule)
  },
  {
    path: 'faild-Booking', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/admin/components/requests/booking/faild-booking/faild-booking.module').then(m => m.FaildBookingModule)
  },
  {
    path: 'completed-Booking', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/admin/components/requests/booking/complete-booking/complete-booking.module').then(m => m.CompleteBookingModule)
  },
  {
    path: 'users', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/admin/components/requests/users/users.module').then(m => m.UsersModule)
  },
  {
    path: 'get-register', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/admin/components/register/register.module').then(m => m.RegisterModule)
  },
  {
    path: 'notification', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/multi-notification/multi-notification.module').then(m => m.MultiNotificationModule)
  },
  {
    path: 'medical-specialties', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/medical/medical-specialist/medical-specialist.module').then(m => m.MedicalSpecialistModule)
  },
  {
    path: 'sub-medical-specialties', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/medical/sub-medical/sub-medical.module').then(m => m.SubMedicalModule)
  },
  {
    path: 'exports', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/exports/exports.module').then(m => m.ExportsModule)
  },
  {
    path: 'attach-file', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/exports/files/files.module').then(m => m.FilesModule)
  },
  {
    path: 'payment', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/super-admin/components/payment/payment.module').then(m => m.PaymentModule)
  },
  {
    path: 'groups', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/admin-content/groups/groups.module').then(m => m.GroupsModule)
  },
  {
    path: 'blogs', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/admin-content/blog/blog.module').then(m => m.BlogModule)
  },
  {
    path: 'new-services', canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/admin-content/new-services/new-services.module').then(m => m.NewServicesModule)
  },
  {
    path: "service-within-subservice", canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/public-role/services/services.module').then(m => m.ServicesModule)
  },
  {
    path: "new-offers", canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/public-role/new-offers/new-offers.module').then(m => m.NewOffersModule)
  },
  {
    path: "existing-users", canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/admin-content/booking/booking.module').then(m => m.BookingModule)
  },
  {
    path: "services-provided", canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/public-role/services-provided/services-provided.module').then(m => m.ServicesProvidedModule)
  },
  {
    path: "orders", canActivate: [AuthGuard],
    loadChildren: () => import('./project-roles/admin/components/orders/orders.module').then(m => m.OrdersModule)
  },
  {
    path: "**", redirectTo: "healthcare", pathMatch: "full"
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
